import { determineStandardAssetClass } from '@/utils/asset-class';

export interface AllocationForRowLite {
  allocation_percentage: number;
  allocation_value?: number | null;
  asset_type?: string;
  fund?: { asset_class?: string };
}

export interface PortfolioRowLike {
  portfolio_size?: number;
  portfolio_allocations?: AllocationForRowLite[];
}

export function computeClassTotals(p: PortfolioRowLike) {
  const size = Math.max(0, p.portfolio_size || 0);
  const sums: Record<string, number> = {
    equity: 0,
    fixed_income: 0,
    cash: 0,
    alternative: 0,
    multi_asset: 0,
  };

  (p.portfolio_allocations || []).forEach((a) => {
    const rawClass = a?.fund?.asset_class;
    let std = determineStandardAssetClass(rawClass, a?.asset_type);
    if (std === 'unclassified') std = 'multi_asset';
    const value = (typeof a.allocation_value === 'number' && a.allocation_value !== null)
      ? Math.max(0, a.allocation_value || 0)
      : ((Math.max(0, a.allocation_percentage || 0) / 100) * size);

    if (std in sums) {
      sums[std] += value;
    }
  });

  const total = Object.values(sums).reduce((acc, v) => acc + v, 0);
  // Round for stability
  Object.keys(sums).forEach((k) => { sums[k] = Math.round(sums[k] * 100) / 100; });
  const roundedTotal = Math.round(total * 100) / 100;

  return { ...sums, total: roundedTotal } as {
    equity: number; fixed_income: number; cash: number; alternative: number; multi_asset: number; total: number;
  };
}
